module.exports = __webpack_public_path__ + "img/docker-stencil.677ede12.svg";